import { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import LinearProgress from '../../component/linearProgress/LinearProgress';
import {
  TOTAL_SERIES,
  itemEquipmentBreakdown,
  itemEquipmentBreakdownFetching,
  itemProductUtilizationAll,
  itemProductUtilizationAllFetching,
} from '../../redux/slices/tools/toolsSlice';
import { useDispatch } from '../../redux/store';
import { BreakdownSummary } from './BreakdownSummary';

// Tools > Products: the dashboard's Products view on its own page, across
// every product category.
export const ToolsProducts = (): ReactElement => {
  const dispatch = useDispatch();
  const breakdownFetching = useSelector(itemEquipmentBreakdownFetching);
  const utilizationFetching = useSelector(itemProductUtilizationAllFetching);

  useEffect(() => {
    dispatch(itemEquipmentBreakdown());
    dispatch(itemProductUtilizationAll());
  }, [dispatch]);

  const fetching = breakdownFetching || utilizationFetching;

  return (
    <>
      {fetching && <LinearProgress />}
      <BreakdownSummary category={TOTAL_SERIES} only="products" manufacturerFetching={fetching} productFetching={fetching} />
    </>
  );
};
